import PropTypes from 'prop-types'

import { TableRow, TableCell } from 'components/Table'
import {
  MenuButton,
  PaymentOrderButtonAction,
  Permitted,
  ChipPaymentOrder,
  VisiblePaymentPaid,
} from 'components'

import helpers from 'helpers'
import constants from 'constants/index'

const PaymentOrdersTableRow = ({ paymentOrder, refresh, setLoading }) => {
  return (
    <>
      <TableRow key={paymentOrder?.id}>
        <TableCell>{paymentOrder?.id}</TableCell>
        <TableCell>{paymentOrder?.paymentMethod || '-'}</TableCell>
        <TableCell>{paymentOrder?.gateway || '-'}</TableCell>
        <TableCell>
          R$ {helpers.formatters.currencyInput(paymentOrder?.price)}
        </TableCell>
        <TableCell align="center">
          {paymentOrder?.expirationDate
            ? helpers.formatters.date(paymentOrder?.expirationDate)
            : '-'}
        </TableCell>
        <TableCell align="center">
          <VisiblePaymentPaid paymentOrder={paymentOrder} />
        </TableCell>
        <TableCell align="center">
          {helpers.formatters.date(
            paymentOrder?.orderReferenceDate,
            'MM/YYYY',
          ) || '-'}
        </TableCell>
        <TableCell>{paymentOrder?.dataNfe?.nNfse || '-'}</TableCell>
        <TableCell disableTooltip noOverFlow align="center">
          <ChipPaymentOrder paymentOrder={paymentOrder} />
        </TableCell>
        <TableCell disableTooltip noOverFlow>
          <Permitted tag={constants.permissions.PAYMENT_ORDERS.MANAGE_PAYMENT}>
            <MenuButton>
              <PaymentOrderButtonAction
                paymentOrder={paymentOrder}
                refresh={refresh}
                setLoading={setLoading}
              />
            </MenuButton>
          </Permitted>
        </TableCell>
      </TableRow>
    </>
  )
}

PaymentOrdersTableRow.propTypes = {
  paymentOrder: PropTypes.object,
}

export default PaymentOrdersTableRow
